import { CallHistoryList } from "@constructorfleet/ui/design-system";
import { RefreshIcon } from "@constructorfleet/ui";
import { useCallback, useEffect, useState } from "react";
import type { BhgAdminUser, ProductDbClient } from "@constructorfleet/bhg-product-core";
import { loadCallHistory } from "@constructorfleet/bhg-product-core";
import { TranscriptText } from "../../transcript-text";

export function CallHistoryPanel({ dbClient }: { dbClient: ProductDbClient }) {
  const [users, setUsers] = useState<BhgAdminUser[]>([]);

  useEffect(() => {
    if (dbClient.listUsers) {
      void dbClient.listUsers().then(setUsers);
    }
  }, [dbClient]);

  const loadCalls = useCallback(() => loadCallHistory(dbClient), [dbClient]);

  const userLabel = useCallback(
    (id: number) => {
      const user = users.find((u) => u.id === id);
      return user ? `${user.username} (#${id})` : `User #${id}`;
    },
    [users]
  );

  return (
    <CallHistoryList
      loadCalls={loadCalls}
      userLabel={userLabel}
      renderTranscript={(text) => <TranscriptText text={text} />}
      idPrefix="call-history"
      refreshIcon={<RefreshIcon />}
    />
  );
}
